import { Vec3 } from './vec3'

export class Thrust extends Vec3 {}
